export default __webpack_public_path__ + "static/media/JohnBenevente.6cba9b61.jpg";